import React from 'react';

import { Icon } from 'common/icon';
import { BORDER_RADIUS } from 'constants/sizes';

import { Container } from './styles';
import { AvatarProps } from './types';

export const Avatar = ({
  src,
  image,
  style,
  onClick,
  placeholderIcon,
  borderStyle = 'round',
}: AvatarProps) => {
  const imageURI = React.useMemo(() => {
    if (image) {
      if (image.file) return URL.createObjectURL(image.file);
      if (image.original) return image.original;
    }

    return src;
  }, [image, src]);

  return (
    <Container
      onClick={onClick}
      disabled={!onClick}
      style={{ borderRadius: BORDER_RADIUS[borderStyle], ...style }}
    >
      {placeholderIcon && <Icon icon={placeholderIcon} />}
      {imageURI && <img src={imageURI} />}
    </Container>
  );
};
